import { FunctionComponent } from 'react';

import { StreamConnected } from '../stream';
import { WinResultLayerConnected } from '../winResultLayer';

import { BalanceCellConnected } from './cells/balanceCell';
import { BettingGridCellConnected } from './cells/bettingGridCell';
import { ChipStackCellConnected } from './cells/chipStackCell';
import { LeftControlsCellConnected } from './cells/leftControlsCell';
import { LeftDrawerCellConnected } from './cells/leftDrawerCell';
import { RightControlsCellConnected } from './cells/rightControlsCell';
import { RightDrawerCellConnected } from './cells/rightDrawerCell';
import { TotalBetCellConnected } from './cells/totalBetCell';
import { TrafficLightCellConnected } from './cells/trafficLightCell';
import { GameGridContextProvider } from './GameGridContext';
import { GameGridWrapperConnected } from './wrapper/GameGridWrapperConnected';

interface GameGridProps {}

export const GameGridConnected: FunctionComponent<GameGridProps> = () => {
  return (
    <GameGridContextProvider>
      <WinResultLayerConnected />
      <StreamConnected />
      <GameGridWrapperConnected>
        <TrafficLightCellConnected />

        <LeftDrawerCellConnected />
        <RightDrawerCellConnected />

        <BettingGridCellConnected />

        <LeftControlsCellConnected />
        <ChipStackCellConnected />
        <RightControlsCellConnected />

        <BalanceCellConnected />
        <TotalBetCellConnected />
      </GameGridWrapperConnected>
    </GameGridContextProvider>
  );
};
